<template>
    <div class="month">
        <el-select v-model="time" size="large" class="selectBox" @change="handlePageChange">
            <el-option v-for="item in timeData" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
        <div class="dataList">
            <div class="itemBox">
                <span class="bg"></span>
                <span class="num">
                    <span>{{monthActivityData[0]}}</span>
                    <span class="t">场</span>
                </span>
                <span class="tip">当前收录赛事</span>
            </div>
            <div class="itemBox">
                <span class="bg"></span>
                <span class="num">
                    <span>{{monthActivityData[1]}}</span>
                    <span class="t">人</span>
                </span>
                <span class="tip">本月预计参赛人数</span>
            </div>
            <div class="itemBox">
                <span class="bg"></span>
                <span class="num">
                    <span>{{monthActivityData[2]}}</span>
                    <span class="t">人</span>
                </span>
                <span class="tip">预计线下潜在曝光量</span>
            </div>
            <div class="itemBox">
                <span class="bg"></span>
                <span class="num">{{month}}月{{monthActivityData[3]}}日</span>
                <span class="tip">赛事最多一天</span>
            </div>
            <div class="itemBox">
                <span class="bg"></span>
                <span class="num">
                    <span>{{monthActivityData[4]}}</span>
                </span>
                <span class="tip">赛事最多省份</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        monthActivityData: {
            type: Array,
            defaul: function() {
                return []
            }
        },
        timeData: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            time: '',
            month: new Date().getMonth() + 1,
        }
    },
    methods: {
        handlePageChange() {
            this.month = this.time.split('-')[1] < 10 ? this.time.split('-')[1][1] : this.time.split('-')[1]
            this.$emit('changeMonth', this.time)
        }
    },
}
</script>

<style lang="scss" scoped>
.month{
    padding-top: 12px;
}
.title{
    margin-top: 24px;
    color: #fff;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 13px;
}
.dataList{
    display: flex;
    overflow: hidden;
    justify-content: space-between;
    background-color: #292941;
    padding: 40px;
    border-radius: 12px;
}
.itemBox{
    background-color: #2E2E48;
    min-width: 222px;
    min-height: 222px;
    border-radius: 50%;
    text-align: center;
    color: #fff;
    padding-top: 53px;
    box-sizing: border-box;
    flex-direction: row;
    // justify-content: center;
    .bg{
        width: 48px;
        height: 48px;
        display: block;
        margin: 0 auto 15px;
    }
    .tip{
        color: #A1A1CC;
        font-size: 14px;
        line-height: 1;
        display: block;
    }
    .num{
        margin-bottom: 12px;
        display: block;
        font-size: 26px;
        line-height: 26px;
    }
    .t{
        color: #8585CF;
        font-size: 14px;
    }
}
.itemBox:nth-child(1) {
    .bg{
        background: url('../../../../../assets/images/jiangbei.png') center center / 48px 48px no-repeat;
    }
}
.itemBox:nth-child(2) {
    .bg{
        background: url('../../../../../assets/images/group.png') center center / 48px 48px no-repeat;
    }
}
.itemBox:nth-child(3) {
    .bg{
        background: url('../../../../../assets/images/visible.png') center center / 48px 48px no-repeat;
    }
}
.itemBox:nth-child(4) {
    .bg{
        background: url('../../../../../assets/images/fire.png') center center / 48px 48px no-repeat;
    }
}
.itemBox:nth-child(5) {
    .bg{
        background: url('../../../../../assets/images/marker.png') center center / 48px 48px no-repeat;
    }
}
.selectBox{
    border-radius: 12px;
    // margin-bottom: 12px;
    overflow: hidden;
}
::v-deep .el-input__inner{
    background-color: #151522;
    border: none;
    color: #A1A1CC
}
</style>
